<template>
  <div>
    <HeaderPage href="/service"/>
    <div class="neiBanner">
        <div class="textBanner wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <dl>LOGIN IN</dl>
            <dt>社会化服务事业部</dt>
        </div>
    </div>
    <div class="login">
        <div class="tit wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <h3>欢迎访问浙江国正安全技术有限公司社会化服务事业部</h3>
            本系统需登陆以后方可使用
        </div>
        <div class="box wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <ul>
                <li>
                    <dl>帐号：</dl><input type="text" name="account" class="account">
                </li>
                <li>
                    <dl>密码：</dl><input type="password" name="password" class="password">
                </li>
                <li>
                    <dl>验证码：</dl><input type="text" name="yzm" class="yzm">
                    <a onclick="re_captcha()" style="width: 120px;height:40px;">
                        <img src="/wOPRsxe/code?tmp=1" id="captcha_img">
                    </a>
                </li>
                <ol><button class="submitMsg" type="button">登陆</button><a href="/wOPRsxe/regist">注册</a>
                </ol>
            </ul>
        </div>
    </div>
    <FooterPage />
  </div>
</template>
  
<script setup>
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
</script>

<style scoped>
.neiBanner {
  height: 500px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background:url('@/assets/images/bg/A3ZZ0c.jpg');
}
.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  font-weight: bold;
}
.neiBanner .textBanner dl {
  font-size: 72px;
}
.neiBanner .textBanner dt {
  font-size: 30px;
  font-weight: 500;
}
.login {
  width: 970px;
  margin: 70px auto 110px;
}
.login .tit {
  font-size: 24px;
  text-align: center;
  color: #666666;
  line-height: 1.8;
  margin-bottom: 60px;
}
.login .tit h3 {
  font-size: 30px;
  font-weight: normal;
}
.login .box {
  background: #f3f3f3;
  box-shadow: 0 0 20px rgba(0, 0, 0, .2);
  padding: 90px 0 65px;
}
.login .box ul {
  width: 500px;
  margin: 0 auto;
}
.login .box ul li {
  display: flex;
  margin-bottom: 30px;
}
.login .box ul li dl {
  width: 85px;
  font-size: 18px;
  color: #073c7d;
  text-align: center;
  line-height: 38px;
  flex: 0 0 auto;
}
.login .box ul input {
  width: 100%;
  border: #c8c8c8 solid 1px;
  height: 38px;
  padding: 0 10px;
}
.login .box ul ol {
  text-align: center;
  display: flex;
  justify-content: center;
}
.login .box ul button, .login .box ul a {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #073c7d;
  color: #fff;
  display: block;
  border: none;
  margin: 0 3px;
  cursor: pointer;
}
</style>